import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14 7.25h-1A5 5 0 0 0 8.75 3V2a.75.75 0 0 0-1.5 0v1A5 5 0 0 0 3 7.25H2a.75.75 0 0 0 0 1.5h1A5.06 5.06 0 0 0 7.25 13v1a.75.75 0 0 0 1.5 0v-1A5.06 5.06 0 0 0 13 8.75h1a.75.75 0 0 0 0-1.5Zm-6 4.32A3.57 3.57 0 1 1 11.57 8 3.57 3.57 0 0 1 8 11.57ZM10.4 8A2.4 2.4 0 1 1 8 5.6 2.4 2.4 0 0 1 10.4 8Z';
const draw24px =
  'M16,12a4,4,0,1,1-4-4A4,4,0,0,1,16,12Zm6.75,0a.74.74,0,0,1-.75.75H19.91a8,8,0,0,1-7.16,7.16V22a.75.75,0,0,1-1.5,0V19.91a8,8,0,0,1-7.16-7.16H2a.75.75,0,0,1,0-1.5H4.09a8,8,0,0,1,7.16-7.16V2a.75.75,0,0,1,1.5,0V4.09a8,8,0,0,1,7.16,7.16H22A.75.75,0,0,1,22.75,12Zm-4.3,0A6.45,6.45,0,1,0,12,18.45,6.45,6.45,0,0,0,18.45,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TargetIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'target'),
) as IconWithRender;

TargetIcon.displayName = 'TargetIcon';
TargetIcon.propTypes = Icon.propTypes;
TargetIcon.renderIcon = (props) => <TargetIcon {...props} />;
export default TargetIcon;
